import React, { useCallback } from 'react'
import ContentCopyIcon from '@material-symbols/svg-300/outlined/content_copy.svg'

import Button from '../Button/Button'
import Field from '../Field/Field'

import styles from './CopyToClipboard.module.scss'

const copyToClipboard = async (text: string) => {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text)
      return
    } catch (_err) {
      // Fall through to fallback
    }
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

export default React.memo(function CopyToClipboardButton({ text }: { text: string }) {
  const handleCopy = useCallback(() => copyToClipboard(text), [text])

  return (
    <Field className={styles.CopyToClipboard}>
      <div className={styles.content}>{text}</div>
      <Button tiny onClick={handleCopy} className={styles.copyButton}>
        <ContentCopyIcon />
      </Button>
    </Field>
  )
})
